import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { WarmUpService } from 'app/services/warmup/warmup.service';
import { SystemDivision } from './system-division.model';

import { ClientHeaderService } from './../client-header.service';

@Component({
    selector: 'app-system-division',
    templateUrl: './system-division.component.html'
})

/**
 * Component to load system division popup.
 */
export class SystemDivisionComponent implements OnInit {
    systemDivisions: SystemDivision[];
    clientId: number;

    constructor(
        public dialogRef: MdDialogRef<any>,
        private warmUpService: WarmUpService,
        private clientHeaderService: ClientHeaderService,
        private snackBarService: SnackBarService) { }

    ngOnInit() {
    }

    onSelect(value: SystemDivision) {
        const postSystemData = {
            'clientId': this.clientId,
            'divisionCode': value.code,
            'hid': value.hid,
        };
        this.clientHeaderService.selectSystemDivision(postSystemData)
            .subscribe(response => {
                if (response.flagResult) {
                    this.dialogRef.close(null);
                }
                this.callSnackBarService(response,
                    MessageService.SELECT_SYSTEM_DIVISION_SUCCESS,
                    MessageService.SELECT_SYSTEM_DIVISION_FAILURE);
            }, err => {
                this.callSnackBarService(err,
                    MessageService.SELECT_SYSTEM_DIVISION_SUCCESS,
                    MessageService.SELECT_SYSTEM_DIVISION_FAILURE);
            });
    }

    callSnackBarService(response: any, successMsg: string, failureMsg: string) {
        this.snackBarService.showStatus(response, successMsg, failureMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/clients/client/header/systemdivision/system-division.component.ts